import { PageInfo } from '../types';

let isReady = false;

const queue: PageInfo[] = [];

/**
 * adobeDataLayer 보장 함수
 */
const ensureAdobeDataLayer = (): PageInfo[] => {
  if (!window.adobeDataLayer) {
    window.adobeDataLayer = [];
  }

  return window.adobeDataLayer;
};

/**
 * Adobe Analytics Client
 */
export const AdobeClient = {
  setReady(value: boolean) {
    isReady = value;
  },

  push(payload: PageInfo) {
    if (!isReady) {
      console.log('adobe queue push >>>>>>');
      queue.push(payload);
      return;
    }

    const dataLayer = ensureAdobeDataLayer();

    console.log('adobe dataLayer push >>>>>> ', payload);
    dataLayer.push(payload);
  },

  flush() {
    queue.forEach((p) => AdobeClient.push(p));
    queue.length = 0;
  },

  isReady,
};
